import {
  DatabaseService,
  SalesOrder,
  SalesOrderData,
  SalesOrderRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getSalesOrderRepository(
  databaseService: DatabaseService,
): SalesOrderRepository {
  return getGenericRepository<SalesOrder, SalesOrderData>(
    () => DatabaseCollection.SALES_ORDERS,
    databaseService,
  );
}
